<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <form v-on:submit.prevent="handleSubmit">
          <div class="loading" v-if="loading"></div>
          <h4>Store Editor</h4>
          <perfect-scrollbar class="modalContenCnt">
            <div class="fieldGroup flex">
              <input type="text" class="field f75" placeholder="Label"
                v-model="form.label.model">
              <input type="text" class="field f12" placeholder="Code"
                v-model="form.code.model">
            </div>
            <div :class="{fieldGroup: true, hasError: form.name.error}">
              <input type="text" class="field" placeholder="Name"
                v-model="form.name.model" v-on:input="fieldChanged('name')">
              <div class="fieldError" v-if="form.name.error">
                Please input name to continue.</div>
            </div>
            <div class="fieldGroup">
              <input type="text" class="field" placeholder="Phone"
                v-model="form.phone.model">
            </div>
            <div class="fieldGroup">
              <textarea placeholder="Address..."
                class="field" rows="3" v-model="form.address.model"/>
            </div>
            <div class="fieldGroup flex">
              <div class="f75Cnt">
                <input type="text" class="field f15 f15a" placeholder="City"
                  v-model="form.city.model">
                <input type="text" class="field f15 f15b" placeholder="Province"
                  v-model="form.province.model">
              </div>
              <input type="text" class="field f13" placeholder="Pos Code"
                v-model="form.pos_code.model">
            </div>
            <div class="fieldGroup">
              <input type="text" class="field" placeholder="Google Map Url"
                v-model="form.map_uri.model">
            </div>
            <h5 class="formTitle">Opening Hour</h5>
            <div class="fieldGroup flex">
              <div class="fieldCnt f16">
                <label>Senin</label>
                <input type="text" class="field" placeholder="Senin"
                  v-model="form.open_hour_mon.model">
              </div>
              <div class="fieldCnt f16">
                <label>Selasa</label>
                <input type="text" class="field" placeholder="Selasa"
                  v-model="form.open_hour_tue.model">
              </div>
              <div class="fieldCnt f16">
                <label>Rabu</label>
                <input type="text" class="field" placeholder="Rabu"
                  v-model="form.open_hour_wed.model">
              </div>
              <div class="fieldCnt f16 f16x">
                <label>Kamis</label>
                <input type="text" class="field" placeholder="Kamis"
                  v-model="form.open_hour_thu.model">
              </div>
            </div>
            <div class="fieldGroup flex">
              <div class="fieldCnt f16">
                <label>Jum'at</label>
                <input type="text" class="field" placeholder="Jum'at"
                  v-model="form.open_hour_fri.model">
              </div>
              <div class="fieldCnt f16">
                <label>Sabtu</label>
                <input type="text" class="field" placeholder="Sabtu"
                  v-model="form.open_hour_sat.model">
              </div>
              <div class="fieldCnt f16">
                <label>Minggu</label>
                <input type="text" class="field" placeholder="Minggu"
                  v-model="form.open_hour_sun.model">
              </div>
            </div>
          </perfect-scrollbar>
          <div class="modalAction">
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit"><span>Save</span></button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'addArticleCategory',
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      data: null,
      form: {
        label: { model: '' },
        code: { model: '' },
        name: { model: '', error: null },
        phone: { model: '' },
        address: { model: '' },
        city: { model: '' },
        province: { model: '' },
        pos_code: { model: '' },
        map_uri: { model: '' },
        open_hour_mon: { model: '' },
        open_hour_tue: { model: '' },
        open_hour_wed: { model: '' },
        open_hour_thu: { model: '' },
        open_hour_fri: { model: '' },
        open_hour_sat: { model: '' },
        open_hour_sun: { model: '' },
      },
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.data = d;
      this.form.label.model = (d && d.label) ? d.label : '';
      this.form.code.model = (d && d.code) ? d.code : '';
      this.form.name.model = (d && d.name) ? d.name : '';
      this.form.phone.model = (d && d.phone) ? d.phone : '';
      this.form.address.model = (d && d.address) ? d.address : '';
      this.form.city.model = (d && d.city) ? d.city : '';
      this.form.province.model = (d && d.province) ? d.province : '';
      this.form.pos_code.model = (d && d.pos_code) ? d.pos_code : '';
      this.form.map_uri.model = (d && d.google_map_link) ? d.google_map_link : '';
      this.form.open_hour_mon.model = (d && d.open_hour_mon) ? d.open_hour_mon : '';
      this.form.open_hour_tue.model = (d && d.open_hour_tue) ? d.open_hour_tue : '';
      this.form.open_hour_wed.model = (d && d.open_hour_wed) ? d.open_hour_wed : '';
      this.form.open_hour_thu.model = (d && d.open_hour_thu) ? d.open_hour_thu : '';
      this.form.open_hour_fri.model = (d && d.open_hour_fri) ? d.open_hour_fri : '';
      this.form.open_hour_sat.model = (d && d.open_hour_sat) ? d.open_hour_sat : '';
      this.form.open_hour_sun.model = (d && d.open_hour_sun) ? d.open_hour_sun : '';
      this.next = n;
      this.show = true;
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    handleSubmit() {
      const formData = {
        label: this.form.label.model,
        code: this.form.code.model,
        name: this.form.name.model,
        phone: this.form.phone.model,
        address: this.form.address.model,
        city: this.form.city.model,
        province: this.form.province.model,
        pos_code: this.form.pos_code.model,
        map_uri: this.form.map_uri.model,
        open_hour_mon: this.form.open_hour_mon.model,
        open_hour_tue: this.form.open_hour_tue.model,
        open_hour_wed: this.form.open_hour_wed.model,
        open_hour_thu: this.form.open_hour_thu.model,
        open_hour_fri: this.form.open_hour_fri.model,
        open_hour_sat: this.form.open_hour_sat.model,
        open_hour_sun: this.form.open_hour_sun.model,
      };
      if (!formData.name || formData.name === '') {
        this.form.name.error = true;
        return;
      }
      if (this.data) {
        formData.id = this.data.id;
      }
      this.loading = true;
      this.$http.post(this.$config.uri('misc/amway-store'), formData).then((r) => {
        this.loading = false;
        this.close(true, r.data.data);
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
};
</script>

<style scoped lang="scss">
  .sliderImg{
    height: 160px;
    background-color: #eee;
    border-radius: 7px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color .3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    .addPhoto{
      color: #999;
      font-weight: bold;
      font-size: 18px;
      transition: all .3s ease;
      img{
        height: 46px;
        opacity: .3;
        display: block;
        margin: 0 auto 6px;
        transition: all .3s ease;
      }
      &.changePhoto{
        color: #fff;
        opacity: 0;
        background-color: rgba(0,0,0,.5);
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          opacity: 1;
        }
      }
    }
    &.theSlider{
      width: 100px; height: 100px;
      .addPhoto{
        img{
          height: 30px;
        }
        font-size: 14px;
      }
    }
    &:hover{
      background-color: #e5e5e5;
      .addPhoto{
        color: #767676;
        img{
          opacity: .4;
        }
        &.changePhoto{
          opacity: 1;
          color: #fff;
          img{
            opacity: 1;
          }
        }
      }
    }
    &.hasError{
      border: red 2px solid;
      box-sizing: border-box;
      background-color: #fff3f3;
    }
  }

  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 0;
      border-radius: 5px;
      margin-top: -20px;
      text-align: center;
      overflow: hidden;
      max-width: none;
      width: 640px;
      .modalContenCnt{
        max-height: 70vh;
        box-sizing: border-box;
        padding: 20px 80px 0;
      }
      h4.sliderTitle{
        font-size: 12px;
        text-transform: uppercase;
        font-weight: 600;
        color: #999;
        margin: 16px 7px 6px;
      }
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .formTitle{
        font-size: 13px;
        margin: 0 5px 10px;
        text-align: left;
        text-transform: uppercase;
        color: #999;
        font-weight: 600;
      }
      .fieldGroup{
        .fieldCnt{
          position: relative;
          label{
            background-color: #fff;
            display: inline-block;
            position: absolute;
            z-index: 2;
            left: 10px; top: -6px;
            padding: 0 6px;
            text-transform: none;
            font-weight: normal;
            color: #222;
            font-size: 11px;
          }
        }
        &.flex{
          display: flex;
          .f12{
            width: 170px;
            margin-left: 16px;
          }
          .f13{
            width: 100px;
            margin-left: 16px;
          }
          .f16{
            width: calc(25% - 12px);
            margin-right: 16px;
            &.f16x{
              margin-right: 0;
            }
          }
          .f75Cnt{
            display: flex;
            .f15{
              width: calc(50% - 8px);
              &.f15a{
                margin-right: 8px;
              }
              &.f15b{
                margin-left: 8px;
              }
            }
          }
        }
        label.checkLabel{
          text-align: left;
          text-transform: none;
          color: #444;
          margin: 0;
          padding: 5px 0;
          cursor: pointer;
          font-size: 17px;
          font-weight: 600;
          input{
            margin: 0;
            margin-left: 3px;
            margin-top: 4px;
            margin-right: 10px;
            float: left;
          }
        }
      }
      textarea{
        margin-top: 20px;
      }
      h4{
        margin: 0;
        border-bottom: #eee 1px solid;
        padding: 0 80px 14px;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        text-align: left;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 0 0 -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .deleteCat{
          position: absolute;
          left: 30px; top: 22px;
          color: red; cursor: pointer;
          padding-left: 22px;
          opacity: .8;
          &:before{
            display: block;
            content: "";
            position: absolute;
            left: 0; top: 0;
            width: 16px; height: 20px;
            background-image: url(../assets/delete.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            opacity: 1;
          }
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
